/*
 * @file: pages.js
 * @description: Reducers and actions
 * @author: faisal
 */

import * as TYPE from '../../actions/constants'

/******** Reducers ********/
const initialState = {
    rewards: null
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case TYPE.REWARD:
            return {
                ...state,
                rewards: action.data
            }
        default:
            return initialState
    }
}
